//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('sopCls', {
//        templateUrl: 'views/components/views/sopCls/sopCls.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'sopClsService', function ($stateParams, stateService, utilityService, sopClsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let sopKeyno = $stateParams.sop_keyno;
            
//            vm.model = {
//                setting: {},
//                itemsListChoices: []
//            };

//            // #region VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await sopClsService.getSetting({ sop_keyno: sopKeyno }))[0];
//            }
            
//            async function loadChoices() {
//                if (utilityService.validateParmsValue(vm.model.setting.sop_keyno) !== true) return;
                
//                return vm.model.itemsListChoices = await sopClsService.listChoices({ sop_keyno: vm.model.setting.sop_keyno });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'sopcl':
//                        go({
//                            sop_keyno: vm.model.setting.sop_keyno,
//                            sopcl_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadChoices();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
